webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(54)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(14),
  /* template */
  __webpack_require__(70),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Quiz__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Quiz___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Quiz__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    Quiz: __WEBPACK_IMPORTED_MODULE_0__components_Quiz___default.a
  },
  data: function data() {
    return {
      startedQuiz: false,
      questions: [{
        component: 'Equation0',
        first: 'synthesis',
        second: [2, 1, 2],
        questionA: 'Calculate the number of water (H<sub>2</sub>O) molecules formed if 0.562 moles of oxygen gas (O<sub>2</sub>) react.',
        answerA: ['6.77', '6.76'],
        answerTemplateA: 'x 10<sup>23</sup> <b>molecules</b>',
        questionB: 'Determine the moles of oxygen gas (O<sub>2</sub>) needed to completely react with 1.975 moles of hydrogen gas (H<sub>2</sub>).',
        answerB: ['0.9875', '.9875'],
        answerTemplateB: '<b>moles</b>'
      }, {
        component: 'Equation1',
        first: 'synthesis',
        second: [4, 3, 2],
        questionA: 'Determine the number of moles of oxygen gas (O<sub>2</sub>) that are needed to react with 0.725 moles of aluminum (Al).',
        answerA: ['0.544', '.544'],
        answerTemplateA: '<b>moles</b>',
        questionB: 'Calculate the mass of aluminum oxide (Al<sub>2</sub>O<sub>3</sub>) produced if 25.00 g of Aluminum (Al) is reacted completely.',
        answerB: ['47.23', '47.24', '47.25'],
        answerTemplateB: '<b>grams</b>'
      }, {
        component: 'Equation2',
        first: 'decomposition',
        second: [1, 1, 1],
        questionA: 'How many carbon dioxide (CO<sub>2</sub>) molecules are produced during the decomposition of 1.25 moles of Carbonic acid (H<sub>2</sub>CO<sub>3</sub>)?',
        answerA: ['7.53'],
        answerTemplateA: 'x 10<sup>23</sup> <b>molecules</b>',
        questionB: 'Determine the number of water (H<sub>2</sub>O) molecules produced by the reaction if 7.25 x 10<sup>23</sup> molecules of carbon dioxide (CO<sub>2</sub>) are made.',
        answerB: ['7.25'],
        answerTemplateB: 'x 10<sup>23</sup> <b>molecules</b>'
      }, {
        component: 'Equation3',
        first: 'decomposition',
        second: [2, 1, 3],
        questionA: 'Determine the mass of Iron (III) oxide (Fe<sub>2</sub>O<sub>3</sub>) produced in the decomposition reaction of 100.0 grams of Iron (III) hydroxide (Fe(OH)<sub>3</sub>).',
        answerA: ['74.71'],
        answerTemplateA: '<b>grams</b>',
        questionB: 'Calculate the number of water (H<sub>2</sub>O) molecules produced from the decomposition of 75.50 grams of Iron (III) hydroxide (Fe(OH)<sub>3</sub>).',
        answerB: ['6.381'],
        answerTemplateB: 'x 10<sup>23</sup> <b>molecules</b>'
      }, {
        component: 'Equation4',
        first: 'single replacement',
        second: [2, 1, 1, 2],
        questionA: 'Determine the mass of silver (Ag) produced in the reaction if 6.50x10<sup>23</sup> atoms of magnesium (Mg) react.',
        answerA: ['233'],
        answerTemplateA: '<b>grams</b>',
        questionB: 'Determine the mass of magnesium (Mg) needed to react with 0.955 moles of silver nitrate (AgNO<sub>3</sub>).',
        answerB: ['11.6'],
        answerTemplateB: '<b>grams</b>'
      }, {
        component: 'Equation5',
        first: 'single replacement',
        second: [2, 3, 2, 1],
        questionA: 'Calculate the mass of aluminum (Al) produced if 0.862 moles of Magnesium (Mg) react.',
        answerA: ['15.5'],
        answerTemplateA: '<b>grams</b>',
        questionB: 'Determine the mass of aluminum (Al) produced in the reaction if 30.00 grams of magnesium (Mg) was consumed.',
        answerB: ['22.20'],
        answerTemplateB: '<b>grams</b>'
      }, {
        component: 'Equation6',
        first: 'double replacement',
        second: [1, 1, 1, 2],
        questionA: 'Calculate the moles of calcium chloride (CaCl<sub>2</sub>) needed to react in order to produce 85.00 grams of calcium carbonate (CaCO<sub>3</sub>).',
        answerA: ['0.8492', '.8492', '0.8493', '.8493'],
        answerTemplateA: '<b>moles</b>',
        questionB: 'Calculate the number of moles of sodium chloride (NaCl) formed if 0.345 moles of calcium chloride (CaCl<sub>2</sub>) react.',
        answerB: ['0.690', '.690'],
        answerTemplateB: '<b>moles</b>'
      }, {
        component: 'Equation7',
        first: 'double replacement',
        second: [2, 1, 2, 1],
        questionA: 'If 175.0 grams of lead (II) iodide (PbI<sub>2</sub>) is produced from the reaction, how many moles of potassium nitrate (KNO3) are produced?',
        answerA: ['0.7592', '.7592'],
        answerTemplateA: '<b>moles</b>',
        questionB: 'If 0.455 moles of potassium iodide (KI) react, what mass of lead (II) iodide (PbI<sub>2</sub>) will be produced?',
        answerB: ['105'],
        answerTemplateB: '<b>grams</b>'
      }, {
        component: 'Equation8',
        first: 'combustion',
        second: [1, 5, 3, 4],
        questionA: 'Determine how many moles of water (H<sub>2</sub>O) are formed from the combustion of 7.50 x 10<sup>23</sup> molecules of propane (C<sub>3</sub>H<sub>8</sub>). ',
        answerA: ['4.98'],
        answerTemplateA: '<b>moles</b>',
        questionB: 'Calculate the number of carbon dioxide (CO<sub>2</sub>) molecules produced in the reaction if 0.7525 moles of oxygen gas (O<sub>2</sub>) are consumed.',
        answerB: ['2.719'],
        answerTemplateB: 'x 10<sup>23</sup> <b>molecules</b>'
      }, {
        component: 'Equation9',
        first: 'combustion',
        second: [2, 7, 4, 6],
        questionA: 'Determine how many carbon dioxide (CO<sub>2</sub>) molecules are produced if 8.45 x 10<sup>23</sup> molecules of water (H<sub>2</sub>O) are produced',
        answerA: ['5.63'],
        answerTemplateA: 'x 10<sup>23</sup> <b>molecules</b>',
        questionB: 'Calculate the number of moles of oxygen gas (O<sub>2</sub>) needed to fully react with 9.75x10<sup>23</sup> molecules of ethane (C<sub>2</sub>H<sub>6</sub>). ',
        answerB: ['5.67'],
        answerTemplateB: '<b>moles</b>'
      }]
    };
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Equation0',
  data: function data() {
    return {
      bottom0: 2,
      bottom1: 2,
      bottom2: 2,
      bottom3: 1
    };
  },
  props: ['secondGuess'],
  watch: {
    secondGuess: {
      handler: function handler(val) {
        this.calcBottoms(false, true);
      },
      deep: true
    }
  },
  methods: {
    calcBottoms: function calcBottoms(event) {
      var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.bottom0 = (parseInt(this.secondGuess[0]) || 1) * 2;
      this.bottom1 = (parseInt(this.secondGuess[1]) || 1) * 2;
      this.bottom2 = (parseInt(this.secondGuess[2]) || 1) * 2;
      this.bottom3 = (parseInt(this.secondGuess[2]) || 1) * 1;

      if (skip !== false) {
        // also emit the change for the parent
        this.$emit('setSecond', this.secondGuess);
      }
    }
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Equation1',
  data: function data() {
    return {
      bottom0: 1,
      bottom1: 2,
      bottom2: 2,
      bottom3: 3
    };
  },
  props: ['secondGuess'],
  watch: {
    secondGuess: {
      handler: function handler(val) {
        this.calcBottoms(false, true);
      },
      deep: true
    }
  },
  methods: {
    calcBottoms: function calcBottoms(event) {
      var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.bottom0 = (parseInt(this.secondGuess[0]) || 1) * 1;
      this.bottom1 = (parseInt(this.secondGuess[1]) || 1) * 2;
      this.bottom2 = (parseInt(this.secondGuess[2]) || 1) * 2;
      this.bottom3 = (parseInt(this.secondGuess[2]) || 1) * 3;

      if (skip !== false) {
        // also emit the change for the parent
        this.$emit('setSecond', this.secondGuess);
      }
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Equation2',
  data: function data() {
    return {
      bottom0: 2,
      bottom1: 1,
      bottom2: 3,
      bottom3: 2,
      bottom4: 1,
      bottom5: 3
    };
  },
  props: ['secondGuess'],
  watch: {
    secondGuess: {
      handler: function handler(val) {
        this.calcBottoms(false, true);
      },
      deep: true
    }
  },
  methods: {
    calcBottoms: function calcBottoms(event) {
      var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.bottom0 = (parseInt(this.secondGuess[0]) || 1) * 2;
      this.bottom1 = (parseInt(this.secondGuess[0]) || 1) * 1;
      this.bottom2 = (parseInt(this.secondGuess[0]) || 1) * 3;
      this.bottom3 = (parseInt(this.secondGuess[1]) || 1) * 2;
      this.bottom4 = (parseInt(this.secondGuess[2]) || 1) * 1;
      // h2o + co2 in the formula, so o gets added twice (bottom5 = the last O in the subtext helper)
      this.bottom5 = (parseInt(this.secondGuess[1]) || 1) * 2 + (parseInt(this.secondGuess[2]) || 1) * 1;

      if (skip !== false) {
        // also emit the change for the parent
        this.$emit('setSecond', this.secondGuess);
      }
    }
  },
  created: function created() {
    // do this 'cause the answer is also the default :P
    this.$emit('setSecond', this.secondGuess);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Equation3',
  data: function data() {
    return {
      bottom0: 1,
      bottom1: 3,
      bottom2: 3,
      bottom3: 2,
      bottom4: 4,
      bottom5: 2
    };
  },
  props: ['secondGuess'],
  watch: {
    secondGuess: {
      handler: function handler(val) {
        this.calcBottoms(false, true);
      },
      deep: true
    }
  },
  methods: {
    calcBottoms: function calcBottoms(event) {
      var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.bottom0 = (parseInt(this.secondGuess[0]) || 1) * 1;
      this.bottom1 = (parseInt(this.secondGuess[0]) || 1) * 3;
      this.bottom2 = (parseInt(this.secondGuess[0]) || 1) * 3;
      this.bottom3 = (parseInt(this.secondGuess[1]) || 1) * 2;
      // fe2o3+ h2o in the formula, so o gets added twice (bottom4 = the last O in the subtext helper)
      this.bottom4 = (parseInt(this.secondGuess[1]) || 1) * 3 + (parseInt(this.secondGuess[2]) || 1) * 1;
      this.bottom5 = (parseInt(this.secondGuess[2]) || 1) * 2;

      if (skip !== false) {
        // also emit the change for the parent
        this.$emit('setSecond', this.secondGuess);
      }
    }
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Equation4',
  data: function data() {
    return {
      bottom0: 1,
      bottom1: 1,
      bottom2: 3,
      bottom3: 1,
      bottom4: 1,
      bottom5: 2,
      bottom6: 6,
      bottom7: 1
    };
  },
  props: ['secondGuess'],
  watch: {
    secondGuess: {
      handler: function handler(val) {
        this.calcBottoms(false, true);
      },
      deep: true
    }
  },
  methods: {
    calcBottoms: function calcBottoms(event) {
      var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.bottom0 = (parseInt(this.secondGuess[0]) || 1) * 1;
      this.bottom1 = (parseInt(this.secondGuess[0]) || 1) * 1;
      this.bottom2 = (parseInt(this.secondGuess[0]) || 1) * 3;
      this.bottom3 = (parseInt(this.secondGuess[1]) || 1) * 1;
      this.bottom4 = (parseInt(this.secondGuess[3]) || 1) * 1;
      this.bottom5 = (parseInt(this.secondGuess[2]) || 1) * 2;
      this.bottom6 = (parseInt(this.secondGuess[2]) || 1) * 6;
      this.bottom7 = (parseInt(this.secondGuess[2]) || 1) * 1;

      if (skip !== false) {
        // also emit the change for the parent
        this.$emit('setSecond', this.secondGuess);
      }
    }
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Equation5',
  data: function data() {
    return {
      bottom0: 1,
      bottom1: 1,
      bottom2: 4,
      bottom3: 1,
      bottom4: 1,
      bottom5: 2,
      bottom6: 8,
      bottom7: 3
    };
  },
  props: ['secondGuess'],
  watch: {
    secondGuess: {
      handler: function handler(val) {
        this.calcBottoms(false, true);
      },
      deep: true
    }
  },
  methods: {
    calcBottoms: function calcBottoms(event) {
      var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.bottom0 = (parseInt(this.secondGuess[0]) || 1) * 1;
      this.bottom1 = (parseInt(this.secondGuess[0]) || 1) * 1;
      this.bottom2 = (parseInt(this.secondGuess[0]) || 1) * 4;
      this.bottom3 = (parseInt(this.secondGuess[1]) || 1) * 1;
      this.bottom4 = (parseInt(this.secondGuess[2]) || 1) * 1;
      this.bottom5 = (parseInt(this.secondGuess[3]) || 1) * 2;
      this.bottom6 = (parseInt(this.secondGuess[3]) || 1) * 8;
      this.bottom7 = (parseInt(this.secondGuess[3]) || 1) * 3;

      if (skip !== false) {
        // also emit the change for the parent
        this.$emit('setSecond', this.secondGuess);
      }
    }
  }
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Equation6',
  data: function data() {
    return {
      bottom0: 2,
      bottom1: 1,
      bottom2: 3,
      bottom3: 1,
      bottom4: 2,
      bottom5: 1,
      bottom6: 1,
      bottom7: 3,
      bottom8: 1,
      bottom9: 1
    };
  },
  props: ['secondGuess'],
  watch: {
    secondGuess: {
      handler: function handler(val) {
        this.calcBottoms(false, true);
      },
      deep: true
    }
  },
  methods: {
    calcBottoms: function calcBottoms(event) {
      var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.bottom0 = (parseInt(this.secondGuess[0]) || 1) * 2;
      this.bottom1 = (parseInt(this.secondGuess[0]) || 1) * 1;
      this.bottom2 = (parseInt(this.secondGuess[0]) || 1) * 3;
      this.bottom3 = (parseInt(this.secondGuess[1]) || 1) * 1;
      this.bottom4 = (parseInt(this.secondGuess[1]) || 1) * 2;
      this.bottom5 = (parseInt(this.secondGuess[3]) || 1) * 1;
      this.bottom6 = (parseInt(this.secondGuess[2]) || 1) * 1;
      this.bottom7 = (parseInt(this.secondGuess[2]) || 1) * 3;
      this.bottom8 = (parseInt(this.secondGuess[2]) || 1) * 1;
      this.bottom9 = (parseInt(this.secondGuess[3]) || 1) * 1;

      if (skip !== false) {
        // also emit the change for the parent
        this.$emit('setSecond', this.secondGuess);
      }
    }
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Equation7',
  data: function data() {
    return {
      bottom0: 1,
      bottom1: 1,
      bottom2: 1,
      bottom3: 2,
      bottom4: 6,
      bottom5: 1,
      bottom6: 2,
      bottom7: 1,
      bottom8: 1,
      bottom9: 3
    };
  },
  props: ['secondGuess'],
  watch: {
    secondGuess: {
      handler: function handler(val) {
        this.calcBottoms(false, true);
      },
      deep: true
    }
  },
  methods: {
    calcBottoms: function calcBottoms(event) {
      var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.bottom0 = (parseInt(this.secondGuess[0]) || 1) * 1;
      this.bottom1 = (parseInt(this.secondGuess[0]) || 1) * 1;
      this.bottom2 = (parseInt(this.secondGuess[1]) || 1) * 1;
      this.bottom3 = (parseInt(this.secondGuess[1]) || 1) * 2;
      this.bottom4 = (parseInt(this.secondGuess[1]) || 1) * 6;
      this.bottom5 = (parseInt(this.secondGuess[2]) || 1) * 1;
      this.bottom6 = (parseInt(this.secondGuess[3]) || 1) * 2;
      this.bottom7 = (parseInt(this.secondGuess[3]) || 1) * 1;
      this.bottom8 = (parseInt(this.secondGuess[2]) || 1) * 1;
      this.bottom9 = (parseInt(this.secondGuess[2]) || 1) * 3;

      if (skip !== false) {
        // also emit the change for the parent
        this.$emit('setSecond', this.secondGuess);
      }
    }
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Equation8',
  data: function data() {
    return {
      bottom0: 3,
      bottom1: 8,
      bottom2: 2,
      bottom3: 1,
      bottom4: 2,
      bottom5: 3
    };
  },
  props: ['secondGuess'],
  watch: {
    secondGuess: {
      handler: function handler(val) {
        this.calcBottoms(false, true);
      },
      deep: true
    }
  },
  methods: {
    calcBottoms: function calcBottoms(event) {
      var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.bottom0 = (parseInt(this.secondGuess[0]) || 1) * 3;
      this.bottom1 = (parseInt(this.secondGuess[0]) || 1) * 8;
      this.bottom2 = (parseInt(this.secondGuess[1]) || 1) * 2;
      this.bottom3 = (parseInt(this.secondGuess[2]) || 1) * 1;
      this.bottom4 = (parseInt(this.secondGuess[3]) || 1) * 2;
      // co2+ h2o in the formula, so o gets added twice (bottom5 = the last O in the subtext helper)
      this.bottom5 = (parseInt(this.secondGuess[2]) || 1) * 2 + (parseInt(this.secondGuess[3]) || 1) * 1;

      if (skip !== false) {
        // also emit the change for the parent
        this.$emit('setSecond', this.secondGuess);
      }
    }
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'Equation9',
  data: function data() {
    return {
      bottom0: 2,
      bottom1: 6,
      bottom2: 2,
      bottom3: 1,
      bottom4: 2,
      bottom5: 3
    };
  },
  props: ['secondGuess'],
  watch: {
    secondGuess: {
      handler: function handler(val) {
        this.calcBottoms(false, true);
      },
      deep: true
    }
  },
  methods: {
    calcBottoms: function calcBottoms(event) {
      var skip = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.bottom0 = (parseInt(this.secondGuess[0]) || 1) * 2;
      this.bottom1 = (parseInt(this.secondGuess[0]) || 1) * 6;
      this.bottom2 = (parseInt(this.secondGuess[1]) || 1) * 2;
      this.bottom3 = (parseInt(this.secondGuess[2]) || 1) * 1;
      this.bottom4 = (parseInt(this.secondGuess[3]) || 1) * 2;
      // co2+ h2o in the formula, so o gets added twice (bottom5 = the last O in the subtext helper)
      this.bottom5 = (parseInt(this.secondGuess[2]) || 1) * 2 + (parseInt(this.secondGuess[3]) || 1) * 1;

      if (skip !== false) {
        // also emit the change for the parent
        this.$emit('setSecond', this.secondGuess);
      }
    }
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Equation0__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Equation0___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Equation0__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Equation1__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Equation1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__Equation1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Equation2__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Equation2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Equation2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Equation3__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Equation3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Equation3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Equation4__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Equation4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Equation4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Equation5__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Equation5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__Equation5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Equation6__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Equation6___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Equation6__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Equation7__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Equation7___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Equation7__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Equation8__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Equation8___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__Equation8__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Equation9__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Equation9___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__Equation9__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'quiz',
  components: {
    Equation0: __WEBPACK_IMPORTED_MODULE_1__Equation0___default.a,
    Equation1: __WEBPACK_IMPORTED_MODULE_2__Equation1___default.a,
    Equation2: __WEBPACK_IMPORTED_MODULE_3__Equation2___default.a,
    Equation3: __WEBPACK_IMPORTED_MODULE_4__Equation3___default.a,
    Equation4: __WEBPACK_IMPORTED_MODULE_5__Equation4___default.a,
    Equation5: __WEBPACK_IMPORTED_MODULE_6__Equation5___default.a,
    Equation6: __WEBPACK_IMPORTED_MODULE_7__Equation6___default.a,
    Equation7: __WEBPACK_IMPORTED_MODULE_8__Equation7___default.a,
    Equation8: __WEBPACK_IMPORTED_MODULE_9__Equation8___default.a,
    Equation9: __WEBPACK_IMPORTED_MODULE_10__Equation9___default.a
  },
  data: function data() {
    return {
      debug: false,
      totalQuestions: 5,
      currentQindex: 0,
      currentsubQindex: 0,
      currentScore: 0,
      randomQuestions: [],
      firstGuess: [],
      firstCheck: '',
      secondGuess: [1, 1, 1, 1],
      secondCheck: '',
      secondWrong: false,
      thirdGuess: [],
      thirdCheck: '',
      thirdWrong: false,
      submitText: 'Submit &xrarr;'
    };
  },
  props: ['questions', 'startedQuiz'],
  methods: {
    resetEverything: function resetEverything() {
      this.currentQindex = 0;
      this.currentScore = 0;
      this.currentsubQindex = 0;
      this.firstGuess = [];
      this.firstCheck = '';
      this.secondGuess = [1, 1, 1, 1];
      this.secondCheck = '';
      this.secondWrong = false;
      this.thirdGuess = [];
      this.thirdCheck = '';
      this.thirdWrong = false;
      this.submitText = 'Submit &xrarr;';
      this.$emit('restartQuiz'); // tell the parent component we're restarting too
      this.randomizeQuestions();
    },
    randomizeQuestions: function randomizeQuestions() {
      if (this.debug === true) {
        var allRandQs = [];
        for (var i = 0; i < this.questions.length; i++) {
          var fakeRandQ1 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.questions[i]);
          var fakeRandQ2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.questions[i]);

          fakeRandQ2.question = this.questions[i]['questionB'];
          fakeRandQ2.answer = this.questions[i]['answerB'];
          fakeRandQ2.answerTemplate = this.questions[i]['answerTemplateB'];
          fakeRandQ2.aorb = 'B';

          fakeRandQ1.question = this.questions[i]['questionA'];
          fakeRandQ1.answer = this.questions[i]['answerA'];
          fakeRandQ1.answerTemplate = this.questions[i]['answerTemplateA'];
          fakeRandQ1.aorb = 'A';

          allRandQs.push(fakeRandQ1, fakeRandQ2);
        }
        this.randomQuestions = allRandQs;
      } else {
        var array = this.questions;
        var currentIndex = array.length;
        var temporaryValue, randomIndex;
        while (currentIndex !== 0) {
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex -= 1;
          temporaryValue = array[currentIndex];
          array[currentIndex] = array[randomIndex];
          array[randomIndex] = temporaryValue;
        }
        this.randomQuestions = array.slice(0, this.totalQuestions);

        for (var j = this.randomQuestions.length - 1; j >= 0; j--) {
          var rand = Math.floor(Math.random() * 2) === 0 ? 'A' : 'B';
          this.randomQuestions[j].question = this.randomQuestions[j]['question' + rand];
          this.randomQuestions[j].answer = this.randomQuestions[j]['answer' + rand];
          this.randomQuestions[j].answerTemplate = this.randomQuestions[j]['answerTemplate' + rand];
          this.randomQuestions[j].aorb = rand;
        }
      }
    },
    currentEqClass: function currentEqClass() {
      var c = [];
      if (this.currentsubQindex !== 0) {
        c.push('on');
      }
      if (this.currentsubQindex === 2) {
        c.push('end');
      }
      if (this.thirdCheck === 'right') {
        c.push('fade');
      }
      return c;
    },
    setFirst: function setFirst() {
      this.firstCheck = '';
    },
    submitFirst: function submitFirst() {
      var currentQ = this.randomQuestions[this.currentQindex];
      if (this.firstGuess[this.currentQindex] === currentQ.first) {
        // already right, just continue
        if (this.firstCheck === 'right') {
          this.currentsubQindex++;
          this.submitText = 'Submit &xrarr;';
        } else {
          this.firstCheck = 'right';
          this.currentScore++;
          this.submitText = 'Continue &xrarr;';
        }
      } else {
        // already wrong, just continue
        if (this.firstCheck === 'wrong') {
          this.currentsubQindex++;
          this.submitText = 'Submit &xrarr;';
        } else {
          this.firstCheck = 'wrong';
          this.submitText = 'Continue &xrarr;';
        }
      }
    },
    setSecond: function setSecond(second) {
      this.secondGuess = second;
      this.secondCheck = '';
    },
    submitSecond: function submitSecond() {
      var currentQ = this.randomQuestions[this.currentQindex];
      var goodToGo = true;

      for (var i = 0; i < currentQ.second.length; i++) {
        // blank can be 1
        if (this.secondGuess[i] === '') {
          this.secondGuess[i] = 1;
        }
        if (parseInt(this.secondGuess[i]) !== currentQ.second[i]) {
          goodToGo = false;
        }
      }
      if (this.secondWrong === 'deadwrong') {
        // continuing
        this.currentsubQindex++;
      } else if (goodToGo !== true) {
        if (this.secondWrong === true) {
          // force correct
          this.secondGuess = [];
          for (var j = 0; j < currentQ.second.length; j++) {
            this.secondGuess[j] = currentQ.second[j];
          }
          this.secondWrong = 'deadwrong';
          this.submitText = 'Continue &xrarr;';
        } else {
          this.secondCheck = 'wrong';
          this.secondWrong = true;
        }
      } else {
        if (this.secondCheck === 'right') {
          if (this.secondWrong === false) {
            this.currentScore++;
          }
          this.currentsubQindex++;
          this.submitText = 'Submit &xrarr;';
        } else {
          this.secondCheck = 'right';
          this.submitText = 'Continue &xrarr;';
        }
      }
    },
    setThird: function setThird() {
      if (this.thirdCheck !== 'deadwrong') {
        this.thirdCheck = '';
      }
    },
    submitThird: function submitThird() {
      var currentQ = this.randomQuestions[this.currentQindex];
      var currentGuess = this.thirdGuess[this.currentQindex] || 0;
      var hasSigFig = false;
      var hasCorrect = false;

      for (var i = 0; i < currentQ.answer.length; i++) {
        if (currentGuess === currentQ.answer[i]) {
          hasCorrect = true;
        }
        if (currentQ.answer[i].indexOf(currentGuess) === 0 || currentGuess.indexOf(currentQ.answer[i]) === 0) {
          hasSigFig = true;
        }
      }

      if (hasCorrect) {
        if (this.thirdCheck === 'wrong') {
          this.thirdCheck = 'right';
        } else {
          this.thirdCheck = 'right';
          this.currentScore++;
        }
      } else if (hasSigFig) {
        this.thirdCheck = 'sigfig';
      } else {
        if (this.thirdWrong === true) {
          this.thirdCheck = 'deadwrong';
          var r = Math.floor(Math.random() * currentQ.answer.length);
          this.thirdGuess[this.currentQindex] = currentQ.answer[r]; // force
        } else {
          this.thirdCheck = 'wrong';
          this.thirdWrong = true; // oh noes
        }
      }
    },
    nextQuestion: function nextQuestion() {
      this.currentQindex++;
      this.submitFirstText = 'Submit &xrarr;';
      this.currentsubQindex = 0;
      this.firstGuess = [];
      this.firstCheck = '';
      this.secondGuess = [1, 1, 1, 1];
      this.secondCheck = '';
      this.secondWrong = false;
      this.thirdGuess = [];
      this.thirdCheck = '';
      this.thirdWrong = false;
    }
  },
  created: function created() {
    this.randomizeQuestions();
  }
});

/***/ }),
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 55 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(15),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(16),
  /* template */
  __webpack_require__(73),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(17),
  /* template */
  __webpack_require__(74),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(18),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(19),
  /* template */
  __webpack_require__(76),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(20),
  /* template */
  __webpack_require__(77),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(21),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(22),
  /* template */
  __webpack_require__(79),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(23),
  /* template */
  __webpack_require__(80),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(55)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(71),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedQuiz === false),
      expression: "startedQuiz === false"
    }],
    key: "intro",
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "intro"
  }, [_c('div', {
    staticClass: "intro-inner"
  }, [_c('h1', [_vm._v("Chemical Reactions and Stoichiometry")]), _vm._v(" "), _c('p', [_vm._v("Classify each chemical reaction, then balance the equation and solve a stoichiometry question based on it.")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.startedQuiz = true
      }
    }
  }, [_vm._v("Begin Quiz")])])])]), _vm._v(" "), _c('quiz', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.startedQuiz === true),
      expression: "startedQuiz === true"
    }],
    key: "quizComponent",
    attrs: {
      "questions": _vm.questions
    },
    on: {
      "restartQuiz": function($event) {
        _vm.startedQuiz = false
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 71 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentQindex < _vm.totalQuestions),
      expression: "currentQindex < totalQuestions"
    }],
    attrs: {
      "id": "score"
    }
  }, [_c('div', {
    staticClass: "col-1-3 left"
  }, [_vm._v("Stoichiometry")]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3 center"
  }, [_vm._v("question " + _vm._s(_vm.currentQindex + 1) + " / " + _vm._s(_vm.totalQuestions))]), _vm._v(" "), _c('div', {
    staticClass: "col-1-3 right"
  }, [_vm._v("score: " + _vm._s(_vm.currentScore) + " / " + _vm._s(_vm.totalQuestions * 3))])])]), _vm._v(" "), _c('transition-group', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentQindex < _vm.totalQuestions),
      expression: "currentQindex < totalQuestions"
    }],
    key: "questionsstart"
  }, _vm._l((_vm.randomQuestions), function(q, index) {
    return _c('div', {
      key: 'q' + index
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === _vm.currentQindex),
        expression: "index === currentQindex"
      }],
      key: 'qi' + index
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.debug === true),
        expression: "debug === true"
      }],
      staticClass: "debug"
    }, [_vm._v("\n            Question " + _vm._s(_vm.currentQindex + 1) + " part " + _vm._s(_vm.currentsubQindex + 1)), _c('br'), _vm._v("\n            component: " + _vm._s(q.component)), _c('br'), _vm._v("\n            ANSWERS:"), _c('br'), _vm._v("\n            part 1: [ " + _vm._s(q.first) + " ]"), _c('br'), _vm._v("\n            part 2: " + _vm._s(q.second)), _c('br'), _vm._v("\n            part 3: " + _vm._s(q.answer) + " (" + _vm._s(q.aorb) + ")"), _c('br')]), _vm._v(" "), _c('div', {
      staticClass: "question"
    }, [_c('div', {
      staticClass: "subQs"
    }, [_c('div', {
      staticClass: "wrap"
    }, [(_vm.currentsubQindex == 0) ? _c('p', [_vm._v("Classify the following reaction")]) : _vm._e(), _vm._v(" "), (_vm.currentsubQindex == 1) ? _c('p', [_vm._v("Balance the equation")]) : _vm._e(), _vm._v(" "), (_vm.currentsubQindex == 2) ? _c('p', {
      class: _vm.thirdCheck == 'right' ? 'faded' : '',
      domProps: {
        "innerHTML": _vm._s(q.question)
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "equation",
      class: _vm.currentEqClass()
    }, [_c(q.component, {
      key: q.component,
      tag: "component",
      attrs: {
        "secondGuess": _vm.secondGuess
      },
      on: {
        "update:secondGuess": function($event) {
          _vm.secondGuess = $event
        },
        "setSecond": function($event) {
          _vm.setSecond($event)
        }
      }
    })], 1), _vm._v(" "), (_vm.currentsubQindex == 0) ? _c('div', {
      staticClass: "wrap"
    }, [_c('div', {
      staticClass: "part-1-answers radio-inputs"
    }, _vm._l((['decomposition', 'synthesis', 'single replacement', 'double replacement', 'combustion']), function(answer, i) {
      return _c('span', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (_vm.firstGuess[index]),
          expression: "firstGuess[index]"
        }],
        attrs: {
          "disabled": _vm.firstCheck != '' ? true : false,
          "name": index + '_guess-option',
          "id": index + '_' + i,
          "type": "radio",
          "autocomplete": "off"
        },
        domProps: {
          "value": answer,
          "checked": _vm._q(_vm.firstGuess[index], answer)
        },
        on: {
          "change": function($event) {
            _vm.$set(_vm.firstGuess, index, answer)
          }
        }
      }), _vm._v(" "), _c('label', {
        class: [{
          wasnt: (q.first == answer)
        }, _vm.firstCheck],
        attrs: {
          "for": index + '_' + i
        },
        on: {
          "click": _vm.setFirst
        }
      }, [_vm._v(_vm._s(answer))])])
    })), _vm._v(" "), _c('div', {
      staticClass: "submit"
    }, [(_vm.firstCheck == 'wrong') ? _c('p', {
      staticClass: "wrong red"
    }, [_vm._v("Sorry, that is incorrect.")]) : _vm._e(), _vm._v(" "), (_vm.firstCheck == 'right') ? _c('p', {
      staticClass: "wrong"
    }, [_vm._v("Correct!")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": _vm.submitFirst
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.submitText)
      }
    })])])]) : _vm._e(), _vm._v(" "), (_vm.currentsubQindex == 1) ? _c('div', {
      staticClass: "wrap"
    }, [_c('div', {
      staticClass: "submit"
    }, [(_vm.secondCheck == 'wrong') ? _c('p', {
      staticClass: "wrong red"
    }, [_vm._v("Sorry, that is incorrect. Please try again.")]) : _vm._e(), _vm._v(" "), (_vm.secondWrong == 'deadwrong') ? _c('p', {
      staticClass: "wrong red"
    }, [_vm._v("Sorry, that is incorrect. The correct answer is shown.")]) : _vm._e(), _vm._v(" "), (_vm.secondCheck == 'right') ? _c('p', {
      staticClass: "wrong"
    }, [_vm._v("Correct!")]) : _vm._e(), _vm._v(" "), _c('button', {
      staticClass: "btn",
      on: {
        "click": _vm.submitSecond
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.submitText)
      }
    })])])]) : _vm._e(), _vm._v(" "), (_vm.currentsubQindex == 2) ? _c('div', {
      staticClass: "part-3-container wrap",
      class: [{
        fade: (_vm.thirdCheck == 'right')
      }, {
        fader: (_vm.thirdCheck == 'deadwrong')
      }]
    }, [_c('div', {
      staticClass: "part-3-answers equation on"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.thirdGuess[index]),
        expression: "thirdGuess[index]"
      }],
      attrs: {
        "type": "text",
        "pattern": "[0-9]*[.,]?[0-9]+",
        "autocomplete": "off",
        "step": "0.0001"
      },
      domProps: {
        "value": (_vm.thirdGuess[index])
      },
      on: {
        "focus": _vm.setThird,
        "click": _vm.setThird,
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.thirdGuess, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(q.answerTemplate)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "submit"
    }, [(_vm.thirdCheck == 'wrong') ? _c('p', {
      staticClass: "red"
    }, [_vm._v("Sorry, that value is incorrect. Please recheck your calculations and try again.")]) : _vm._e(), _vm._v(" "), (_vm.thirdCheck == 'deadwrong') ? _c('p', {
      staticClass: "red"
    }, [_vm._v("Sorry, that value is incorrect. The correct answer is shown.")]) : _vm._e(), _vm._v(" "), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.thirdCheck != 'wrong' && _vm.thirdCheck != 'deadwrong'),
        expression: "thirdCheck != 'wrong' && thirdCheck != 'deadwrong'"
      }],
      staticClass: "sigfig",
      class: _vm.thirdCheck == 'sigfig' ? 'red' : ''
    }, [_vm._v("Final answers should be reported with the correct number of significant digits")]), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.thirdCheck != 'deadwrong'),
        expression: "thirdCheck != 'deadwrong'"
      }],
      staticClass: "btn",
      on: {
        "click": _vm.submitThird
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.submitText)
      }
    })])]), _vm._v(" "), (_vm.thirdCheck == 'right') ? _c('div', {
      staticClass: "q-complete"
    }, [_c('span', [_vm._v("Correct!")]), _c('br'), _vm._v("Question " + _vm._s(_vm.currentQindex + 1) + " Complete\n                ")]) : _vm._e(), _vm._v(" "), (_vm.thirdCheck == 'right' || _vm.thirdCheck == 'deadwrong') ? _c('div', {
      staticClass: "q-next"
    }, [_c('button', {
      staticClass: "btn",
      on: {
        "click": _vm.nextQuestion
      }
    }, [_vm._v("Next Question ⟶")])]) : _vm._e()]) : _vm._e()])])])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentQindex === _vm.totalQuestions),
      expression: "currentQindex === totalQuestions"
    }],
    key: "outroend",
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "outro"
  }, [_c('div', {
    staticClass: "outro-inner"
  }, [_c('h1', [_vm._v("You completed the quiz!")]), _vm._v(" "), _c('p', [_vm._v("Your final score is "), _c('span', [_vm._v(_vm._s(_vm.currentScore))]), _vm._v(" / " + _vm._s(_vm.totalQuestions * 3))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    attrs: {
      "id": "reset"
    },
    on: {
      "click": _vm.resetEverything
    }
  }, [_vm._v("Start over")])])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[0]),
      expression: "secondGuess[0]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 0, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("H"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(g)")]), _vm._v(" + \n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[1]),
      expression: "secondGuess[1]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("O"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(g)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("H="), _c('span', [_vm._v(_vm._s(_vm.bottom0))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom1))])])])]), _vm._v(" "), _c('div', {
    staticClass: "a"
  }, [_vm._v("\n      ⟶ \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[2]),
      expression: "secondGuess[2]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 2, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("H"), _c('sub', [_vm._v("2")]), _vm._v("O "), _c('sub', [_vm._v("(g)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("H="), _c('span', [_vm._v(_vm._s(_vm.bottom2))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom3))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 73 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[0]),
      expression: "secondGuess[0]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 0, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Al "), _c('sub', [_vm._v("(s)")]), _vm._v(" + \n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[1]),
      expression: "secondGuess[1]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("O"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(g)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Al="), _c('span', [_vm._v(_vm._s(_vm.bottom0))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom1))])])])]), _vm._v(" "), _c('div', {
    staticClass: "a"
  }, [_vm._v("\n      ⟶ \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[2]),
      expression: "secondGuess[2]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 2, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Al"), _c('sub', [_vm._v("2")]), _vm._v("O"), _c('sub', [_vm._v("3")]), _vm._v(" "), _c('sub', [_vm._v("(s)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Al="), _c('span', [_vm._v(_vm._s(_vm.bottom2))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom3))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 74 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[0]),
      expression: "secondGuess[0]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 0, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("H"), _c('sub', [_vm._v("2")]), _vm._v("CO"), _c('sub', [_vm._v("3")]), _vm._v(" "), _c('sub', [_vm._v("(aq)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("H="), _c('span', [_vm._v(_vm._s(_vm.bottom0))])]), _vm._v(" "), _c('span', [_vm._v("C="), _c('span', [_vm._v(_vm._s(_vm.bottom1))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom2))])])])]), _vm._v(" "), _c('div', {
    staticClass: "a"
  }, [_vm._v("\n      ⟶ \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[1]),
      expression: "secondGuess[1]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("H"), _c('sub', [_vm._v("2")]), _vm._v("O "), _c('sub', [_vm._v("(l)")]), _vm._v(" + \n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[2]),
      expression: "secondGuess[2]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 2, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("CO"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(g)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("H="), _c('span', [_vm._v(_vm._s(_vm.bottom3))])]), _vm._v(" "), _c('span', [_vm._v("C="), _c('span', [_vm._v(_vm._s(_vm.bottom4))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom5))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[0]),
      expression: "secondGuess[0]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 0, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Fe(OH)"), _c('sub', [_vm._v("3")]), _vm._v(" "), _c('sub', [_vm._v("(s)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Fe="), _c('span', [_vm._v(_vm._s(_vm.bottom0))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom1))])]), _vm._v(" "), _c('span', [_vm._v("H="), _c('span', [_vm._v(_vm._s(_vm.bottom2))])])])]), _vm._v(" "), _c('div', {
    staticClass: "a"
  }, [_vm._v("\n      ⟶ \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[1]),
      expression: "secondGuess[1]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Fe"), _c('sub', [_vm._v("2")]), _vm._v("O"), _c('sub', [_vm._v("3")]), _vm._v(" "), _c('sub', [_vm._v("(s)")]), _vm._v(" + \n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[2]),
      expression: "secondGuess[2]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 2, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("H"), _c('sub', [_vm._v("2")]), _vm._v("O "), _c('sub', [_vm._v("(g)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Fe="), _c('span', [_vm._v(_vm._s(_vm.bottom3))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom4))])]), _vm._v(" "), _c('span', [_vm._v("H="), _c('span', [_vm._v(_vm._s(_vm.bottom5))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[0]),
      expression: "secondGuess[0]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 0, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("AgNO"), _c('sub', [_vm._v("3")]), _vm._v(" "), _c('sub', [_vm._v("(s)")]), _vm._v(" +\n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[1]),
      expression: "secondGuess[1]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Mg "), _c('sub', [_vm._v("(s)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Ag="), _c('span', [_vm._v(_vm._s(_vm.bottom0))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom1))])]), _vm._v(" "), _c('span', [_vm._v("N="), _c('span', [_vm._v(_vm._s(_vm.bottom2))])]), _vm._v(" "), _c('span', [_vm._v("Mg="), _c('span', [_vm._v(_vm._s(_vm.bottom3))])])])]), _vm._v(" "), _c('div', {
    staticClass: "a"
  }, [_vm._v("\n      ⟶ \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[2]),
      expression: "secondGuess[2]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 2, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Mg(NO"), _c('sub', [_vm._v("3")]), _vm._v(")"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(s)")]), _vm._v(" + \n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[3]),
      expression: "secondGuess[3]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 3, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Ag "), _c('sub', [_vm._v("(s)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Ag="), _c('span', [_vm._v(_vm._s(_vm.bottom4))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom5))])]), _vm._v(" "), _c('span', [_vm._v("N="), _c('span', [_vm._v(_vm._s(_vm.bottom6))])]), _vm._v(" "), _c('span', [_vm._v("Mg="), _c('span', [_vm._v(_vm._s(_vm.bottom7))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[0]),
      expression: "secondGuess[0]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 0, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("AlPO"), _c('sub', [_vm._v("4")]), _vm._v(" "), _c('sub', [_vm._v("(aq)")]), _vm._v(" +\n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[1]),
      expression: "secondGuess[1]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Mg "), _c('sub', [_vm._v("(s)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Al="), _c('span', [_vm._v(_vm._s(_vm.bottom0))])]), _vm._v(" "), _c('span', [_vm._v("P="), _c('span', [_vm._v(_vm._s(_vm.bottom1))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom2))])]), _vm._v(" "), _c('span', [_vm._v("Mg="), _c('span', [_vm._v(_vm._s(_vm.bottom3))])])])]), _vm._v(" "), _c('div', {
    staticClass: "a"
  }, [_vm._v("\n      ⟶ \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[2]),
      expression: "secondGuess[2]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 2, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Al "), _c('sub', [_vm._v("(s)")]), _vm._v(" + \n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[3]),
      expression: "secondGuess[3]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 3, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Mg"), _c('sub', [_vm._v("3")]), _vm._v("(PO"), _c('sub', [_vm._v("4")]), _vm._v(")"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(aq)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Al="), _c('span', [_vm._v(_vm._s(_vm.bottom4))])]), _vm._v(" "), _c('span', [_vm._v("P="), _c('span', [_vm._v(_vm._s(_vm.bottom5))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom6))])]), _vm._v(" "), _c('span', [_vm._v("Mg="), _c('span', [_vm._v(_vm._s(_vm.bottom7))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[0]),
      expression: "secondGuess[0]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 0, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Na"), _c('sub', [_vm._v("2")]), _vm._v("CO"), _c('sub', [_vm._v("3")]), _vm._v(" "), _c('sub', [_vm._v("(aq)")]), _vm._v(" +\n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[1]),
      expression: "secondGuess[1]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("CaCl"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(aq)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Na="), _c('span', [_vm._v(_vm._s(_vm.bottom0))])]), _vm._v(" "), _c('span', [_vm._v("C="), _c('span', [_vm._v(_vm._s(_vm.bottom1))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom2))])]), _vm._v(" "), _c('span', [_vm._v("Ca="), _c('span', [_vm._v(_vm._s(_vm.bottom3))])]), _vm._v(" "), _c('span', [_vm._v("Cl="), _c('span', [_vm._v(_vm._s(_vm.bottom4))])])])]), _vm._v(" "), _c('div', {
    staticClass: "a"
  }, [_vm._v("\n      ⟶ \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[2]),
      expression: "secondGuess[2]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 2, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("CaCO"), _c('sub', [_vm._v("3")]), _vm._v(" "), _c('sub', [_vm._v("(s)")]), _vm._v(" + \n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[3]),
      expression: "secondGuess[3]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 3, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("NaCl "), _c('sub', [_vm._v("(aq)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("Na="), _c('span', [_vm._v(_vm._s(_vm.bottom5))])]), _vm._v(" "), _c('span', [_vm._v("C="), _c('span', [_vm._v(_vm._s(_vm.bottom6))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom7))])]), _vm._v(" "), _c('span', [_vm._v("Ca="), _c('span', [_vm._v(_vm._s(_vm.bottom8))])]), _vm._v(" "), _c('span', [_vm._v("Cl="), _c('span', [_vm._v(_vm._s(_vm.bottom9))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[0]),
      expression: "secondGuess[0]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 0, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Kl "), _c('sub', [_vm._v("(aq)")]), _vm._v(" +\n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[1]),
      expression: "secondGuess[1]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("Pb(NO"), _c('sub', [_vm._v("3")]), _vm._v(")"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(aq)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("K="), _c('span', [_vm._v(_vm._s(_vm.bottom0))])]), _vm._v(" "), _c('span', [_vm._v("I="), _c('span', [_vm._v(_vm._s(_vm.bottom1))])]), _vm._v(" "), _c('span', [_vm._v("Pb="), _c('span', [_vm._v(_vm._s(_vm.bottom2))])]), _vm._v(" "), _c('span', [_vm._v("N="), _c('span', [_vm._v(_vm._s(_vm.bottom3))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom4))])])])]), _vm._v(" "), _c('div', {
    staticClass: "a"
  }, [_vm._v("\n      ⟶ \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[2]),
      expression: "secondGuess[2]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 2, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("KNO"), _c('sub', [_vm._v("3")]), _vm._v(" "), _c('sub', [_vm._v("(aq)")]), _vm._v(" + \n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[3]),
      expression: "secondGuess[3]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 3, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("PbI"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(s)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("K="), _c('span', [_vm._v(_vm._s(_vm.bottom5))])]), _vm._v(" "), _c('span', [_vm._v("I="), _c('span', [_vm._v(_vm._s(_vm.bottom6))])]), _vm._v(" "), _c('span', [_vm._v("Pb="), _c('span', [_vm._v(_vm._s(_vm.bottom7))])]), _vm._v(" "), _c('span', [_vm._v("N="), _c('span', [_vm._v(_vm._s(_vm.bottom8))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom9))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[0]),
      expression: "secondGuess[0]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 0, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("C"), _c('sub', [_vm._v("3")]), _vm._v("H"), _c('sub', [_vm._v("8")]), _vm._v(" "), _c('sub', [_vm._v("(g)")]), _vm._v(" + \n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[1]),
      expression: "secondGuess[1]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("O"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(g)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("C="), _c('span', [_vm._v(_vm._s(_vm.bottom0))])]), _vm._v(" "), _c('span', [_vm._v("H="), _c('span', [_vm._v(_vm._s(_vm.bottom1))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom2))])])])]), _vm._v(" "), _c('div', {
    staticClass: "a"
  }, [_vm._v("\n      ⟶ \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[2]),
      expression: "secondGuess[2]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 2, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("CO"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(g)")]), _vm._v(" + \n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[3]),
      expression: "secondGuess[3]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 3, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("H"), _c('sub', [_vm._v("2")]), _vm._v("O "), _c('sub', [_vm._v("(g)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("C="), _c('span', [_vm._v(_vm._s(_vm.bottom3))])]), _vm._v(" "), _c('span', [_vm._v("H="), _c('span', [_vm._v(_vm._s(_vm.bottom4))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom5))])])])])])])
},staticRenderFns: []}

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "top"
  }, [_c('div', {
    staticClass: "l"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[0]),
      expression: "secondGuess[0]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 0, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("C"), _c('sub', [_vm._v("2")]), _vm._v("H"), _c('sub', [_vm._v("6")]), _vm._v(" "), _c('sub', [_vm._v("(g)")]), _vm._v(" + \n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[1]),
      expression: "secondGuess[1]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 1, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("O"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(g)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("C="), _c('span', [_vm._v(_vm._s(_vm.bottom0))])]), _vm._v(" "), _c('span', [_vm._v("H="), _c('span', [_vm._v(_vm._s(_vm.bottom1))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom2))])])])]), _vm._v(" "), _c('div', {
    staticClass: "a"
  }, [_vm._v("\n      ⟶ \n    ")]), _vm._v(" "), _c('div', {
    staticClass: "r"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[2]),
      expression: "secondGuess[2]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 2, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("CO"), _c('sub', [_vm._v("2")]), _vm._v(" "), _c('sub', [_vm._v("(g)")]), _vm._v(" + \n      "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.secondGuess[3]),
      expression: "secondGuess[3]"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.secondGuess, 3, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, _vm.calcBottoms]
    }
  }, _vm._l((25), function(opt) {
    return _c('option', [_vm._v(_vm._s(opt))])
  })), _vm._v("H"), _c('sub', [_vm._v("2")]), _vm._v("O "), _c('sub', [_vm._v("(g)")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('span', [_vm._v("C="), _c('span', [_vm._v(_vm._s(_vm.bottom3))])]), _vm._v(" "), _c('span', [_vm._v("H="), _c('span', [_vm._v(_vm._s(_vm.bottom4))])]), _vm._v(" "), _c('span', [_vm._v("O="), _c('span', [_vm._v(_vm._s(_vm.bottom5))])])])])])])
},staticRenderFns: []}

/***/ })
],[13]);


// WEBPACK FOOTER //
// static/js/app.4fb1380863b1eb748700.js